import axios from "axios";
import { headersProvider } from "../pages/utilities";
export const getSignedAgreementList = async ({ page, filters, pageSize }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/agreements/SignedagreementList`,
      { page, filters, pageSize },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const createObligationApi = async ({ body }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/createobligation`,
      { ...body },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const updateObligationApi = async ({ body }) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/updateobligation`,
      { ...body },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error in updating obligation", error);
      throw error;
    });
};

export const editObligationApi = async ({ editData }) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/editobligation`,
      { ...editData },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error in editing obligation!", error);
      throw error;
    });
};
export const bulkUpdateObligationApi = async ( formData ) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/bulkupdateobligation`, formData, {
      headers: {
        ...headersProvider(),
        // "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getObligationsForAgreement = async ({ local, agreementId }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getobligations`,
      { local, agreementId },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getauditHistory = async ({ id }) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/audithistory/${id}`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getCompletedObligation = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/completed`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getAcceptObligations = async ({
  department,
  businessUnit,
  page,
}) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getacceptobligations`,
      { department, businessUnit, page },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};
export const acceptObligation = async ({ id, startDate }) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/acceptobligation`,
      { id, startDate },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getAssignedObligations = async ({
  page,
  pageSize,
  filters,
  sortByOptions,
}) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getassignedobligation`,
      { page, pageSize, filters, sortByOptions },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const fetchDraftObligations = async ({ page, pageSize, filters }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getdraftobligation`,
      { page, pageSize, filters },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getActionedObligations = async ({
  department,
  filters,
  page,
  role,
  pageSize,
  sortByOptions,
}) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getactionedobligation`,
      { department, page, role, pageSize, filters, sortByOptions },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getObligationDetails = async ({ id }) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/getobligationDetails/${id}`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getObligationFiles = async ({ id }) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/attachedfilestobligation/${id}`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const verifyEvidence = async ({ obligationId, fileId }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/verifyevidence`,
      { obligationId, fileId },
      { headers: headersProvider() }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error starting evidence verification", error);
      throw error;
    });
};

export const getVerifyEvidenceStatus = async ({ taskId, fileId, obligationId }) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/verifyevidence/status/${taskId}`, {
      params: { fileId, obligationId },
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error fetching evidence verification status", error);
      throw error;
    });
};

export const getVerifyEvidenceResult = async ({ fileId }) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/verifyevidence/result/${fileId}`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error fetching the stored evidence verification result", error);
      throw error;
    });
};

export const createLocalAgreement = async ({ agreementData }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/createagreement`,
      { agreementData },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getLocalAgreements = async ({ page, filters }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/docslocker`,
      { page, filters },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};
export const getLocalAgreementsCSV = async ({ page, filters }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/docslockercsv`,
      { page, filters },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};
export const getLocalAgreementDetails = async ({ id }) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/localagreement/${id}`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging in!", error);
      throw error;
    });
};

export const getTitlesApi = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/gettitles`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting titles !", error);
      throw error;
    });
};
export const getAllObligations = async ({
  page,
  filters,
  partyName,
  status,
  sortByOptions,
  pageSize,
}) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/getallobligations`,
      { page, filters, partyName, status, pageSize, sortByOptions },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting obligation", error);
      throw error;
    });
};

export const deleteAgreement = async ({ agreementId }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/deletelocalagreement`,
      { agreementId },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error in deleting agreemeent!", error);
      throw error;
    });
};

export const playMasterObligationApi = async ({ id, startDate }) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/playMasterObligation`,
      { id, startDate },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error in playing master obligation!", error);
      throw error;
    });
};
